export default "__VITE_ASSET__ZvBVU_mg__"